import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import {getDatabase,ref,get,onValue } from "firebase/database";
import { getStorage } from "firebase/storage";
import firebaseSettings from "./data/firebaseConfig"; // Corrected import path

var currentSource = {};
var currentApp = null;
var currentdb = null;

// Get the tenant domain mapping database URL from environment variables
const TENANT_DOMAIN_DB_URL = import.meta.env.VITE_DATABASE_TENANTS_DOMAIN_URL || 'https://clientdash-tenants.asia-southeast1.firebasedatabase.app';


async function getAuthOverride() {
    const source = await getCurrentSource();
    const tenantApp = getAppForTenant(source.tenantId);
    const auth = getAuth(tenantApp);
    auth.tenantId = source.tenantId;
    return auth;
}


async function getCurrentTeanantID(){
    return (await getCurrentSource()).tenantId; 
}

async function getCurrentDbName(){
    return (await getCurrentSource()).db; 
}

function getTenantIdMapping(reference) {
    // Create a temporary app for accessing the tenant domain mapping database
    const tempApp = initializeApp({
        apiKey: firebaseSettings.apiKey,
        authDomain: firebaseSettings.authDomain,
        databaseURL: TENANT_DOMAIN_DB_URL,
        projectId: firebaseSettings.projectId,
        storageBucket: firebaseSettings.storageBucket,
        messagingSenderId: firebaseSettings.messagingSenderId,
        appId: firebaseSettings.appId
    }, 'tenant-domain-mapping');

    const database = getDatabase(tempApp);

    return new Promise((resolve, reject) => {
        const dbRef = ref(database, reference);
        onValue(dbRef, (snapshot) => {
            if (snapshot.exists()) {
                resolve(snapshot.val());
            } else {
                reject(new Error('No data available'));
            }
        }, (error) => {
            reject(error);
        }, { onlyOnce: true });
    });
}

async function getCurrentSource(){
    const domain = window.location.hostname;

    try {
        // First, try to get all domain mappings from the database
        const domainsMapping = await getTenantIdMapping('domains');
        if (domainsMapping) {
            // Look for exact domain match first
            if (domainsMapping[domain]) {
                const tenantId = domainsMapping[domain].tenantId;
                return {
                    domain: domain,
                    tenantId: tenantId,
                    db: `https://clientdash-${tenantId}.asia-southeast1.firebasedatabase.app`
                };
            }

            // If no exact match, try to find by converting underscores to dots
            for (const [dbDomain, domainData] of Object.entries(domainsMapping)) {
                const convertedDomain = dbDomain.replace(/_/g, '.');
                if (convertedDomain === domain) {
                    const tenantId = domainData.tenantId;
                    return {
                        domain: domain,
                        tenantId: tenantId,
                        db: `https://clientdash-${tenantId}.asia-southeast1.firebasedatabase.app`
                    };
                }
            }
        }
    } catch (error) {
        console.warn('Failed to fetch domain mappings from database:', error);
    }

    // Fallback: try the old method with underscore conversion
    try {
        var code = "";
        domain.split('.').forEach(function (x) {
            if (!!code) {
                code += "_";
            }
            code += x;
        });

        var tenantId = await getTenantIdMapping(`domains/${code}/tenantId`);
        if (tenantId) {
            return {
                domain: domain,
                tenantId: tenantId,
                db: `https://clientdash-${tenantId}.asia-southeast1.firebasedatabase.app`
            }
        }
    } catch (error) {
        console.warn('Failed to fetch tenant ID using underscore method:', error);
    }

    // Final fallback for localhost development
    if (domain === 'localhost' || domain === '127.0.0.1') {
        return {
            domain: domain,
            tenantId: 'webcoda-jhxrc',
            db: 'https://clientdash-webcoda-jhxrc.asia-southeast1.firebasedatabase.app'
        };
    }

    // If no mapping found, throw an error
    throw new Error(`No tenant mapping found for domain: ${domain}`);
}


function getCurrentDb(){
    return currentdb;
  }

  function getCurrentApp(){
    return currentApp;
  }


const tenantAppsCache = {};

function getAppForTenant(tenantId) {
    if (!tenantAppsCache[tenantId]) {
        tenantAppsCache[tenantId] = initializeApp({
            apiKey: firebaseSettings.apiKey,
            authDomain: firebaseSettings.authDomain,
            databaseURL: `https://clientdash-${tenantId}.asia-southeast1.firebasedatabase.app`,
            projectId: firebaseSettings.projectId,
            storageBucket: firebaseSettings.storageBucket,
            messagingSenderId: firebaseSettings.messagingSenderId,
            appId: firebaseSettings.appId,
            tenantId: tenantId
        }, tenantId);
    }
    return tenantAppsCache[tenantId];    
}



async function tenantMiddleware(req, res, next) {    
    currentSource = await getCurrentSource();

    var firebaseApp = getAppForTenant(currentSource.tenantId);

    currentApp = firebaseApp;
    currentdb = getDatabase(firebaseApp);
  }

async function initializeTenant() {
    currentSource = await getCurrentSource();
    const firebaseApp = getAppForTenant(currentSource.tenantId);
    currentApp = firebaseApp;
    currentdb = getDatabase(firebaseApp);
    return { app: currentApp, db: currentdb, tenantId: currentSource.tenantId };
}


async function tenantStorage() {
    const source = await getCurrentSource();
    const tenantApp = getAppForTenant(source.tenantId);
    return getStorage(tenantApp);
}

export { getAuthOverride as getAuth, getCurrentTeanantID, getCurrentDb as tenantDatabase, getCurrentApp as tenantApp, getCurrentDbName, tenantMiddleware, initializeTenant, tenantStorage };

